import { render, staticRenderFns } from "./c-event-type-field.vue?vue&type=template&id=a3338d84&"
import script from "./c-event-type-field.vue?vue&type=script&lang=js&"
export * from "./c-event-type-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports